/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationMismatchRequestItem
 */
export interface SimulationMismatchRequestItem {
    /**
     * 
     * @type {number}
     * @memberof SimulationMismatchRequestItem
     */
    priceListId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationMismatchRequestItem
     */
    priceList: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationMismatchRequestItem
     */
    year: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationMismatchRequestItem
     */
    product: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMismatchRequestItem
     */
    field: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMismatchRequestItem
     */
    fileValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationMismatchRequestItem
     */
    simulationValue?: string | null;
}

/**
 * Check if a given object implements the SimulationMismatchRequestItem interface.
 */
export function instanceOfSimulationMismatchRequestItem(value: object): value is SimulationMismatchRequestItem {
    if (!('priceListId' in value) || value['priceListId'] === undefined) return false;
    if (!('priceList' in value) || value['priceList'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    return true;
}

export function SimulationMismatchRequestItemFromJSON(json: any): SimulationMismatchRequestItem {
    return SimulationMismatchRequestItemFromJSONTyped(json, false);
}

export function SimulationMismatchRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationMismatchRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'priceListId': json['priceListId'],
        'priceList': json['priceList'],
        'year': json['year'],
        'product': json['product'],
        'field': json['field'],
        'fileValue': json['fileValue'] == null ? undefined : json['fileValue'],
        'simulationValue': json['simulationValue'] == null ? undefined : json['simulationValue'],
    };
}

export function SimulationMismatchRequestItemToJSON(json: any): SimulationMismatchRequestItem {
    return SimulationMismatchRequestItemToJSONTyped(json, false);
}

export function SimulationMismatchRequestItemToJSONTyped(value?: SimulationMismatchRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceListId': value['priceListId'],
        'priceList': value['priceList'],
        'year': value['year'],
        'product': value['product'],
        'field': value['field'],
        'fileValue': value['fileValue'],
        'simulationValue': value['simulationValue'],
    };
}

